import { Grid } from '@mui/material'
import moment from 'moment'
import React, { useEffect } from 'react'
import TableData from '../common/TableData'
import { getLastMovements } from '../../services/sale/servipagosService'
import { useDispatch, useSelector } from 'react-redux'
import { setLastMovements } from '../../redux/slices/sale/airTimeSlice'
import { errorAlert } from '../../helpers/alerts'

const LastSales = ({ list }) => {
  const dispatch = useDispatch();
  const { lastMovements, update } = useSelector(store => store.airTimeSale);

  useEffect(() => {
    getLastMovements()
      .then((response) => dispatch(setLastMovements(response)))
      .catch((e) => errorAlert(e))
    // eslint-disable-next-line
  }, [update])

  return (
    <TableData
      title={'Transacciones'}
      search={false}
      dataRows={lastMovements.map((item) => ({
        ...item,
        style: !item.Result && { color: 'red' }
      }))}
      dataTitle={[
        "Hora",
        "Operadora",
        "Monto",
        "Número",
        "Código",
      ]}
      formatter={({
        createdAt,
        operator,
        Amount,
        phoneNumber,
        ProviderResponseCode,
      }) => ([
        moment(createdAt).format('H:mm:ss '),
        operator?.name,
        `$${Amount || 0}.00`,
        phoneNumber,
        ProviderResponseCode,
      ])}
    />
  )
}

export default LastSales